module.exports = ".menu {\n  width: 250px;\n  position: relative;\n}\n\n.selected {\n  background-color: whitesmoke;\n}\n"